/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable()
export class ApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `ProductsServiceApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
